// extracted by mini-css-extract-plugin
module.exports = {"base":"_3EBerq","buttonWrap":"_3B84gm","button":"_1IN6t5","buttonSkip":"_1iGd9h"};